import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { getPublicMenuInfo } from "../api/club";
import ClubJoinPrompt from "../components/customer-club/ClubJoinPrompt";

export default function OrderSuccess() {
  const navigate = useNavigate();

  const orderInfo = JSON.parse(localStorage.getItem("lastOrder")) || null;
  const menuLink = orderInfo?.menuLink;
  const [club, setClub] = useState(null);

  // Right after ordering is the best moment to invite the guest to the club.
  useEffect(() => {
    if (!menuLink) return;
    getPublicMenuInfo(menuLink)
      .then((info) => info.customerClubEnabled && setClub({ restaurantName: info.restaurant?.name }))
      .catch(() => {});
  }, [menuLink]);

  useEffect(() => {
    if (!localStorage.getItem("lastOrder")) {
      navigate("/"); // اگر بدون سفارش این صفحه باز شد
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#f9fafb] flex flex-col items-center justify-center p-6">
      <div className="bg-white shadow-2xl rounded-2xl p-8 text-center max-w-md w-full">

        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <FiCheckCircle className="text-primary text-8xl" />
        </div>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">
          سفارش شما با موفقیت ثبت شد!
        </h1>
        <p className="text-gray-600 mb-6">
          رستوران در حال آماده‌سازی سفارش شماست.
        </p>

        {/* Order Details */}
        <div className="bg-gray-50 p-5 rounded-xl text-right text-sm space-y-3 ">
          <p>
            <span className="font-semibold text-gray-800">شماره سفارش:</span>{" "}
            {orderInfo?.orderNumber || "نامشخص"}
                      </p>
          <p>
            <span className="font-semibold text-gray-800">مبلغ نهایی:</span>{" "}
            {orderInfo?.totalPrice || 0} تومان
          </p>
          <p>
            <span className="font-semibold text-gray-800">نوع پرداخت:</span>{" "}
            {orderInfo?.paymentType === "online" ? "پرداخت آنلاین" : "نقدی"}
          </p>
          {orderInfo?.tableNumber && (
            <p>
              <span className="font-semibold text-gray-800">شماره میز:</span>{" "}
              {orderInfo.tableNumber}
            </p>
          )}
        </div>

        {club && <ClubJoinPrompt menuLink={menuLink} restaurantName={club.restaurantName} className="mt-5" />}

        {/* Back Button */}
        <button
          className="w-full bg-secondary text-white py-3 mt-6 rounded-md font-bold hover:bg-secondary/90 transition duration-200 shadow-md"
          onClick={() => navigate(`/menu/${orderInfo?.menuLink}`)}
        >
          بازگشت به منو
        </button>
      </div>
    </div>
  );
}